// Shared product-widget styles as plain `sx` objects (migrated off `@mui/styles`/makeStyles).
// Breakpoint note (MUI defaults xs 0 / sm 600 / md 900): an `sx` value set at a breakpoint key
// cascades upward, so `only()`/`down()` rules carry an explicit reset at the next key up.
export const widgetStyles = {
    paper: {
        p: { xs: 0, sm: '20px' },
        pt: { xs: '15px', sm: '20px' },
        borderRadius: '10px',
        height: '100%',
        // outlined Paper border is kept on sm+ and removed on mobile (was `border: none` @ xs).
        // Color is baked into the shorthand: a separate `borderColor: 'divider'` loses the
        // emotion cascade tie to `border: '1px solid'`, leaving a dark currentColor border.
        border: { xs: 'none', sm: '1px solid rgba(0, 0, 0, 0.12)' },
    },
    paperLeft: {
        pb: '20px',
        mr: 0,
    },
    paperRight: {
        pb: '9px',
        ml: 0,
    },
    gridContainer: {
        pb: '20px',
    },
    detailText: {
        fontWeight: 400,
        color: 'text.soft',
        fontSize: { xs: '1rem', md: '1.1rem' },
    },
} as const;
